import { Card, CardBody } from "reactstrap";
import { GoArrowUpRight } from "react-icons/go";

const DashboardDisplayCard = ({ title, subtitle, icon, showIncreaseIcon }) => {
  return (
    <Card
      style={{
        borderRadius: "15px",
      }}
      className="bg-primary-blue text-white border-none"
    >
      <CardBody className="d-flex pt-4 pb-3 flex-row align-items-center justify-content-between">
        <div>
          <h5 className="mb-2 f-5">{title}</h5>
          <p className="m-0 color-half-white  f-4">
            {subtitle}{" "}
            {showIncreaseIcon && (
              <GoArrowUpRight
                style={{ background: "green" }}
                className="full-rounded mx-1"
                color="white"
                size={10}
              />
            )}
          </p>
        </div>
        {icon && icon}
      </CardBody>
    </Card>
  );
};

export default DashboardDisplayCard;
